export var initColumnRefresh = function (column) {
    column.getElement().querySelectorAll('[data-refresh="column"]').forEach(function (element) {
        element.addEventListener('change', function () {
            // Allow other settings to do their thing first so all changes are refreshed correctly
            setTimeout(function () { return column.refresh(); }, 50);
        });
    });
};
